const ClickBoundary = ({ children }) => (
	<div onMouseDown={(e) => e.stopPropagation()}>{children}</div>
);

export default ClickBoundary;